import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Interface from './Interface';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <Interface />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
